export const onlineCartSymbol = 'auto_open_online_cart_symbol';
